import React, { ComponentType, ReactNode } from 'react';
import { EditorPlugin } from '../../draft-js-plugins-editor/src';
import createStore from '../../utils/createStore';
import Toolbar from './components/Toolbar';
import Separator from './components/Separator';
import { defaultTheme } from './theme';

import { EditorState } from 'draft-js';
import { SerializedStyles } from '@emotion/react';

export interface ThemeButtonStyles {
  buttonWrapper?: SerializedStyles;
  button?: SerializedStyles;
  active?: SerializedStyles;
}
export interface InlineToolbarPluginTheme {
  buttonStyles: ThemeButtonStyles;
  toolbarStyles?: {
    toolbar?: SerializedStyles;
  };
  separatorStyles?: {
    separator?: SerializedStyles;
  };
}

export interface InlineToolbarPluginConfig {
  theme: InlineToolbarPluginTheme;
}

export interface StoreProps {
  subscribeToItem: Function;
  unsubscribeFromItem: Function;
  updateItem: Function;
  getItem: Function;
}
export interface ToolbarChildrenProps {
  theme: ThemeButtonStyles;
  getEditorState: () => EditorState;
  setEditorState: (editorState: EditorState) => void;
  onOverrideContent: (content: ComponentType<ToolbarChildrenProps>) => void;
}

export interface ToolbarProps {
  store: StoreProps;
  theme: InlineToolbarPluginTheme;
  isKeyPressing?: boolean;
  onlyCustomCta?: boolean;
  hasStaticToolbar?: boolean;
  isInsideModal?: boolean;
  linkToolbarDisabled?: boolean;
  editorId?: string;
  children(externalProps: ToolbarChildrenProps): ReactNode;
}

export type InlineToolBarPlugin = EditorPlugin & {
  InlineToolbar: ComponentType<ToolbarProps>;
};

export default (config?: InlineToolbarPluginConfig) => {
  const store = createStore({
    isVisible: false,
  });

  const { theme = defaultTheme } = config || { theme: defaultTheme };

  const InlineToolbar = React.forwardRef((props: any, ref) => <Toolbar {...props} store={store} theme={theme}  ref={ref} />);

  return {
    // @ts-ignore
    initialize: ({ getEditorState, setEditorState, getEditorRef }) => {
      store.updateItem('getEditorState', getEditorState);
      store.updateItem('setEditorState', setEditorState);
      store.updateItem('getEditorRef', getEditorRef);
    },
    // Re-Render the text-toolbar on selection change
    onChange: (editorState: any) => {
      store.updateItem('selection', editorState.getSelection());
      return editorState;
    },
    InlineToolbar,
  };
};

export { Separator };
